import {useDebugValue} from 'react';

import classNames from 'classnames';

import {
    useSearchFormContext,
    useTrackingContext
} from '../../../hooks';

import {runHPFormBackgroundExperiment, submitForm} from '../../../utils';

const componentClassName = 'search-form';

function useComponent() {
    const {
        system,
        abacus,
        edap,
        search,
        form,
        form: {
            options: {
                layout,
                align
            }
        },
        destination,
        dates,
        guests
    } = useSearchFormContext();

    const tracking = useTrackingContext();

    const layoutClassName = `${componentClassName}--${layout}`;
    const alignClassName = `${componentClassName}--${align}`;
    const experimentFormBackgroundClassName = `${componentClassName}--experiment-form-background`;

    const className = classNames(componentClassName, layoutClassName, alignClassName, {
        [experimentFormBackgroundClassName]: runHPFormBackgroundExperiment(abacus, system)
    });

    function handleSubmit(event) {
        event.preventDefault();

        submitForm(tracking, system, abacus, edap, search, form, destination, dates, guests);
    }

    const result = {
        className,
        onSubmit: handleSubmit
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
